import React from "react";
import $ from "jquery";

import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Call from "../components/Call";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Contact from "../components/Contact";
import Location from "../components/Location";
import Footer from "../components/Footer";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // Create a ref object
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  scrollToMyRef = () => window.scrollTo(0, this.myRef.current.offsetTop);

  render() {
    return (
      <div>
        <Navbar
          reflink={this.scrollToMyRef}
          logo={
            $(window).width() < 767
              ? "https://www.nabytekbatka.cz/logocodeB.svg"
              : "https://www.nabytekbatka.cz/logocode.svg"
          }
          nav="menu"
        />
        <Hero />
        <Services ref={this.myRef} />
        <Call />
        <Portfolio />
        <About />
        <Contact />
        <Location />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js